import { type IMap } from 'fifa-gis-library'
import { type InjectionKey, type Ref } from 'vue'

export const fifaGisMapSymbol: InjectionKey<Ref<IMap>> = Symbol('fifaGisMap')
export const fifaGisMapLoadedSymbol: InjectionKey<Ref<boolean>> = Symbol('fifaGisMap')
